import React from 'react';
import { FormField } from '../../../../components/FormField';

interface PromotionSecurityProps {
  formData: any;
  property?: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const PromotionSecurity: React.FC<PromotionSecurityProps> = ({
  formData,
  property,
  handleInputChange,
}) => {
  return (
    <div className="space-y-4">
      <h4 className="font-medium text-gray-900 dark:text-white">Sécurité</h4>
      <FormField label="Systèmes de sécurité">
        <div className="grid grid-cols-2 gap-4">
          {[
            { name: 'hasIntercom', dbName: 'has_intercom', label: 'Interphone' },
            { name: 'hasDigicode', dbName: 'has_digicode', label: 'Digicode' },
            { name: 'has_security_cameras', dbName: 'has_security_cameras', label: 'Caméras de surveillance' },
            { name: 'hasGuardian', dbName: 'has_guardian', label: 'Gardien' },
            { name: 'has_generator', dbName: 'has_generator', label: 'Générateur électrique' },
            { name: 'has_fire_alarm', dbName: 'has_fire_alarm', label: 'Alarme incendie' },
            { name: 'has_fire_extinguishers', dbName: 'has_fire_extinguishers', label: 'Extincteurs' },
          ].map(({ name, dbName, label }) => (
            <label key={name} className="flex items-center gap-2">
              <input
                type="checkbox"
                name={name}
                checked={property?.[dbName] ?? formData[name] ?? false}
                onChange={handleInputChange}
              />
              <span>{label}</span>
            </label>
          ))}
        </div>
      </FormField>
    </div>
  );
};